import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-footer-start',
  template: '<ng-content />',
  styleUrls: ['footer-start.component.scss']
})

export class FooterStartComponent {
}
